import React from 'react';

export default function ErrorMessage({ message }) {
  return (
    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded-form my-4">
      <span className="font-bold">Fejl:</span> {message}
    </div>
  );
}
